
export const faqItems = [
  {
    id: 1,
    question: 'Preciso ter experiência com tecnologia para fazer o curso?',
    answer: 'Não! O curso foi pensado para professores de todos os níveis. Começamos do zero, com passo a passo detalhado. Mesmo que você nunca tenha usado ChatGPT ou Gemini, vai conseguir acompanhar e aplicar tudo na sua rotina escolar.'
  },
  {
    id: 2,
    question: 'O que são os Agentes de IA inclusos como bônus?',
    answer: 'São três assistentes de inteligência artificial criados especialmente para professores: um voltado para a Educação Infantil, outro para o Ensino Fundamental e um terceiro especializado em Documentação Pedagógica — que gera PDI, relatórios de AEE, laudos adaptados e planos de ensino individualizados. Eles ajudam a criar planos de aula, atividades, avaliações e documentos pedagógicos completos, tudo adaptado à sua realidade de sala de aula.'
  },
  {
    id: 3,
    question: 'Por quanto tempo terei acesso ao curso?',
    answer: 'O acesso é vitalício! Você pode assistir às aulas quantas vezes quiser, no seu ritmo. Além disso, todas as atualizações futuras do curso serão liberadas automaticamente para você, sem custo adicional.'
  },
  {
    id: 4,
    question: 'O curso oferece certificado?',
    answer: 'Sim! Ao concluir todas as aulas e atividades, você recebe um certificado de conclusão que pode ser utilizado para horas complementares e comprovação de formação continuada.'
  },
  {
    id: 5,
    question: 'E se eu não gostar do curso? Posso pedir reembolso?',
    answer: 'Com certeza! Oferecemos garantia incondicional de 15 dias. Se por qualquer motivo você não ficar satisfeito, basta solicitar o reembolso e devolvemos 100% do seu investimento, sem burocracia.'
  },
  {
    id: 6,
    question: 'Como funciona o suporte via WhatsApp?',
    answer: 'Ao se inscrever, você recebe acesso a um grupo exclusivo no WhatsApp onde pode tirar dúvidas diretamente com nossa equipe e trocar experiências com outros professores. O suporte funciona em dias úteis e as respostas são rápidas e personalizadas.'
  },
  {
    id: 7,
    question: 'Posso aplicar o conteúdo em qualquer disciplina?',
    answer: 'Sim! As ferramentas e técnicas ensinadas no curso são aplicáveis a todas as disciplinas e níveis de ensino. Temos exemplos práticos para Português, Matemática, Ciências, História, Geografia e muito mais.'
  },
  {
    id: 8,
    question: 'O valor de R$ 147,00 é pagamento único?',
    answer: 'Sim, é um pagamento único! Você paga apenas R$ 147,00 e tem acesso completo ao curso, aos três agentes de IA, aos e-books, materiais prontos e todo o suporte. Sem mensalidades ou cobranças extras.'
  }
];
